




































import { Vue, Component } from 'vue-property-decorator'
import PartnerConfigHttp from '@/api'

@Component({
	components: {
	}
})
export default class TokenRedirect extends Vue {
	public token = '';
	public complete = false;
	public error = false;
	async mounted (): Promise<void> {
		this.token = this.$route.query.token as string || '';
		if (this.token.length > 0) {
			const api = new PartnerConfigHttp();
			api.confirmToolUserAccount(this.token).then(() => {
				this.complete = true;
			}).catch((err) => {
				this.complete = true;
				this.error = true;
				throw err;
			});
		}
	}
}
